/**
 *  Created by piotr@revisual.io on 04/08/2025
 */
import IntegrationButton from "../SelectIntegrationPage/IntegrationButton";
import React, { useCallback, useMemo, useState } from "react";
import { AvailableIntegrations } from "../../consts/integrations";

/**
 *
 * @param {Object} form
 * @param {function} setFormField
 * @param {Object} errors
 * @returns {JSX.Element}
 * @constructor
 */
export const SelectIntegrationStep = ({ form, setFormField, errors }) => {
  const [integrationType, setIntegrationType] = useState(form.integration);

  /**
   *
   * @type {function(*): function(*): void}
   */
  const onSelectIntegration = useCallback(
    (type) => (e) => {
      setIntegrationType(type);
      setFormField("integration")(type);
    },
    [setFormField, setIntegrationType]
  );

  const integrations = useMemo(() => {
    const _integrations = AvailableIntegrations.filter((i) => i.available).map(
      (i) => ({
        title: i.title,
        icon: i.icon,
        type: i.type,
      })
    );

    const googleIntegrationIdx = _integrations.findIndex(
      (i) => i.type === "google"
    );
    const googleIntegration = _integrations[googleIntegrationIdx];
    delete _integrations[googleIntegrationIdx];
    _integrations.unshift(googleIntegration);

    return _integrations;
  }, []);

  const integrationOptions = integrations.map((i) => {
    return (
      <IntegrationButton
        key={i.type}
        title={i.title}
        icon={i.icon}
        isSelected={integrationType === i.type}
        onSelect={onSelectIntegration(i.type)}
      />
    );
  });

  return (
    <div>
      <h3 className="account-title">Select Integration</h3>
      <p className="text-muted">
        Select an integration to get started. You can always add more later.
      </p>
      <form>
        <div className={"container"}>
          <div className={"row"}>
            <div className={"col-12"}>
              <div className={"select-integration"}>{integrationOptions}</div>
            </div>
          </div>
        </div>
        <span className={"text-danger"}>{errors.integration}</span>
      </form>
    </div>
  );
};

export default SelectIntegrationStep;
